import styles from "./Checkout.module.css";
import CreditCard from "./CreditCard";
import { Container, Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useEffect } from "react";

function Checkout() {
  const cartProducts = useSelector((state) => state.user.products);
  const totalPrice = cartProducts.reduce(
    (acc, item) => acc + item.price * item.qty,
    0
  );
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <Container className={styles.checkout_container}>
      <h1 className={"text-center " + styles.checkout_title}>Checkout</h1>
      <hr className={styles.hr} />
      <Row className="mt-4 me-2">
        {cartProducts.length > 0 ? (
          <>
            <Col className={styles.checkout_column} md={12} lg={7}>
              {cartProducts.map((product) => (
                <div key={product.id} className={styles.product_container}>
                  <div className={styles.image_container}>
                    <img
                      className={styles.checkout_img}
                      src={product.image}
                      alt="product"
                    />
                  </div>
                  <div className={"ms-3 text-white " + styles.info}>
                    <div className={styles.info_container}>
                      <h4 className={styles.product_name}>{product.name}</h4>
                      <p className={styles.product_description}>
                        {product.type}
                      </p>
                      <div className="d-flex align-items-center">
                        <p className="m-0">Qty: </p>
                        <div className={styles.quantity}>{product.qty}</div>
                      </div>
                    </div>
                    <div>
                      <p className={styles.price}>USD {product.price}</p>
                    </div>
                  </div>
                </div>
              ))}
              <div className={styles.subtitles_container}>
                <div>
                  <h3 className={styles.subtitles}>SUBTOTAL</h3>
                </div>
                <div>
                  <p className={styles.price}>US$ {totalPrice.toFixed(2)}</p>
                </div>
              </div>
              <div className={styles.subtitles_container}>
                <div>
                  <h3 className={styles.subtitles}>SHIPPING</h3>
                </div>
                <div>
                  <p className={styles.price}>Flat Rate: US$ 60</p>
                </div>
              </div>
              <div className={styles.subtitles_container}>
                <div>
                  <h3 className={styles.subtitles}>TOTAL</h3>
                </div>
                <div>
                  <p className={styles.total_price}>
                    US$ {(totalPrice + 60).toFixed(2)}
                  </p>
                </div>
              </div>
            </Col>
            <Col className="text-white" md={12} lg={5}>
              <h3 className={"text-center mb-0 " + styles.title}>
                Shipping information
              </h3>
              <CreditCard totalPrice={totalPrice} />
            </Col>
          </>
        ) : (
          <>
            <Col className={styles.checkout_column} md={12} lg={7}>
              <div
                className={"d-flex flex-column ms-3 text-white " + styles.info}
              >
                <h4 className="mb-3">Oops! Your cart is empty!</h4>
                <Link style={{ color: "#33d5ad" }} to={"/"}>
                  Continue shopping!
                </Link>
              </div>
            </Col>
          </>
        )}
      </Row>
    </Container>
  );
}
export default Checkout;
